import {CommonModule} from '@angular/common';
import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {getOrganizationInitials, resolveOrganizationProfilePicUrl} from '../organization-profile.utils';

@Component({
    selector: 'app-organization-avatar',
    imports: [CommonModule],
    templateUrl: './organization-avatar.component.html',
    styleUrl: './organization-avatar.component.css'
})
export class OrganizationAvatarComponent implements OnChanges {
    @Input() name = '';
    @Input() imageUrl: string | null = null;
    @Input() alt = 'Organization profile image';
    @Input() cssClass = 'profile-img';
    @Input() allowRefresh = true;

    @Output() refreshRequested = new EventEmitter<void>();

    showFallback = false;
    private refreshAttempted = false;

    get initials(): string {
        return getOrganizationInitials(this.name);
    }

    get resolvedImageUrl(): string | null {
        return resolveOrganizationProfilePicUrl({profile_pic_url: this.imageUrl});
    }

    get showImage(): boolean {
        return !this.showFallback && !!this.resolvedImageUrl;
    }

    get showInitials(): boolean {
        return !this.showImage;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['imageUrl']) {
            this.resetState();
        }
    }

    onImageError(): void {
        if (this.resolvedImageUrl?.startsWith('data:')) {
            this.showFallback = true;
            return;
        }
        if (this.allowRefresh && !this.refreshAttempted) {
            this.refreshAttempted = true;
            this.refreshRequested.emit();
            return;
        }
        this.showFallback = true;
    }

    resetState(): void {
        this.showFallback = false;
        this.refreshAttempted = false;
    }
}
